/**
 * Bara cu doua manere pentru filtrul de pret, ca in macheta.
 *
 * De ce element propriu (custom element) si nu un script care ruleaza o data:
 * tema inlocuieste tot blocul de filtre dupa fiecare filtrare, deci un script
 * pornit la incarcarea paginii ar functiona o singura data. Un element propriu
 * se initializeaza singur de fiecare data cand ajunge in pagina.
 *
 * De ce se construieste din JS si nu din Liquid: fara JS bara n-ar putea fi
 * miscata, iar casutele temei raman singura cale de a scrie un interval. Ele
 * sunt ascunse abia dupa ce bara exista, deci pagina ramane folosibila si cand
 * scriptul nu porneste.
 *
 * Filtrarea propriu-zisa NU e facuta aici: valorile sunt scrise in casutele
 * temei, iar acelea anunta formularul de filtre exact ca la scrisul de mana.
 */
class AlmamPriceSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === "true") return;

    const widget = this.parentElement.querySelector(".price__widget");
    if (!widget) return;

    this.minInput = widget.querySelector('input[name$=".gte"], input[id$="-GTE"]');
    this.maxInput = widget.querySelector('input[name$=".lte"], input[id$="-LTE"]');
    if (!this.minInput || !this.maxInput) return;

    this.rangeMax = Math.ceil(parseFloat(this.dataset.max) || 0);
    if (!this.rangeMax) return;

    this.currency = this.dataset.currency || "";
    this.widget = widget;

    this.build();
    this.dataset.ready = "true";
  }

  build() {
    const start = this.clamp(parseFloat(this.minInput.value), 0);
    const end = this.clamp(parseFloat(this.maxInput.value), this.rangeMax);

    this.innerHTML = `
      <div class="almam-price-slider__track">
        <span class="almam-price-slider__fill"></span>
        <input class="almam-price-slider__input almam-price-slider__input--min" type="range"
          min="0" max="${this.rangeMax}" step="1" value="${start}" aria-label="${this.dataset.labelMin || ""}">
        <input class="almam-price-slider__input almam-price-slider__input--max" type="range"
          min="0" max="${this.rangeMax}" step="1" value="${end}" aria-label="${this.dataset.labelMax || ""}">
      </div>
      <div class="almam-price-slider__values">
        <span class="almam-price-slider__value almam-price-slider__value--min"></span>
        <span class="almam-price-slider__value almam-price-slider__value--max"></span>
      </div>
    `;

    this.fill = this.querySelector(".almam-price-slider__fill");
    this.minHandle = this.querySelector(".almam-price-slider__input--min");
    this.maxHandle = this.querySelector(".almam-price-slider__input--max");
    this.minLabel = this.querySelector(".almam-price-slider__value--min");
    this.maxLabel = this.querySelector(".almam-price-slider__value--max");

    // Mutarea manerelor redeseneaza doar bara; filtrul se cere abia la
    // eliberare, altfel fiecare pixel parcurs ar porni o cerere catre magazin.
    [this.minHandle, this.maxHandle].forEach((handle) => {
      handle.addEventListener("input", () => this.redraw());
      handle.addEventListener("change", () => this.commit());
    });

    // Cine scrie in casute (sau le goleste apasand „Reseteaza filtrele")
    // trebuie sa vada manerele mutandu-se odata cu ele.
    [this.minInput, this.maxInput].forEach((input) => {
      input.addEventListener("change", () => this.syncFromInputs());
    });

    this.widget.classList.add("price__widget--sliderized");
    this.redraw();
  }

  clamp(value, fallback) {
    if (Number.isNaN(value) || value === null) return fallback;
    return Math.min(Math.max(Math.round(value), 0), this.rangeMax);
  }

  /** Manerul de minim nu poate trece de cel de maxim, si invers. */
  values() {
    const a = parseInt(this.minHandle.value, 10);
    const b = parseInt(this.maxHandle.value, 10);
    return [Math.min(a, b), Math.max(a, b)];
  }

  redraw() {
    const [low, high] = this.values();

    this.fill.style.left = `${(low / this.rangeMax) * 100}%`;
    this.fill.style.right = `${100 - (high / this.rangeMax) * 100}%`;

    this.minLabel.textContent = this.format(low);
    this.maxLabel.textContent = this.format(high);
  }

  format(value) {
    return this.currency ? `${value} ${this.currency}` : String(value);
  }

  /**
   * Capetele intervalului inseamna „fara limita", deci casuta ramane goala:
   * altfel adresa paginii ar purta un filtru care nu taie nimic.
   */
  commit() {
    const [low, high] = this.values();

    this.minInput.value = low > 0 ? low : "";
    this.maxInput.value = high < this.rangeMax ? high : "";

    this.minInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  syncFromInputs() {
    this.minHandle.value = this.clamp(parseFloat(this.minInput.value), 0);
    this.maxHandle.value = this.clamp(parseFloat(this.maxInput.value), this.rangeMax);
    this.redraw();
  }
}

if (!customElements.get("almam-price-slider")) {
  customElements.define("almam-price-slider", AlmamPriceSlider);
}
